// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Feyvl","select":"styles_select__1xEk3"};